import { render, staticRenderFns } from "./AllTasks.vue?vue&type=template&id=0c40332c&scoped=true&"
import script from "./AllTasks.vue?vue&type=script&lang=ts&"
export * from "./AllTasks.vue?vue&type=script&lang=ts&"
import style0 from "./AllTasks.vue?vue&type=style&index=0&id=0c40332c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c40332c",
  null
  
)

export default component.exports